<style>
	.operatebutton_container .van-button{
		margin: 0 5px;
	}
</style>
<script>
	export default {
		render(h) {
			let params = {
				parent:this,
				row: this.row
			}
			let operateButton = this.rendererList.$operateButton
			if (operateButton) {
				operateButton = operateButton.renderDefault(h, this.operateButton, params)
			}
			return h('div', {
				class: 'operatebutton_container'
			}, operateButton)

		},
		props: {
			row: {
				default: () => {
					return null
				}
			},

			rendererList: {
				default: () => {
					return {}
				}
			},

			operateButton: {
				default: () => {
					return null
				}
			},
			table: {
				default: () => {
					return null
				}
			},
			grid: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				actionShow:false,
				dropdowns:[],
			}
		},
		created() {

		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},

		methods: {

		},
		components: {

		}
	}
</script>
